export default {
  guestTitle: 'Login / Register',
  guestDesc: 'Sign in to unlock deposit, cashback, VIP, favorites and more',
  copy: 'Copy',
  refreshBalance: 'Refresh balance',
  balanceRefreshed: 'Balance refreshed',
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  transfer: 'Transfer',
  recover: 'Recover',
  vipTitle: 'VIP Privileges',
  vipSub: 'Daily · Weekly · Monthly salary & upgrade bonus',
  vipGo: 'View ▶',
  vipGap: 'Need to deposit {amt} more to reach V{level}',
  vipMax: 'Highest VIP level reached',

  rewardTitle: 'Rewards',
  rewardPending: 'Promo · Tasks · Cashback · Salary — {n} ready',
  rewardDone: 'Promo · Tasks · Cashback · Salary — all claimed today',
  claim: 'Claim',
  doTask: 'Do tasks',
  bets: 'Game reports',
  betOrders: 'My bets',
  betTotalStake: 'Total staked',
  betTotalWin: 'Total winnings',
  betCount: 'Bets placed',
  betStakeAmt: 'Amount staked',
  betWinAmt: 'Winnings',
  betViewDetail: 'View details ›',
  betEmpty: 'No bets in this period',
  betLoading: 'Loading…',
  betLoadMore: 'Load more',
  betNoMore: 'No more',
  betTime: 'Bet time',
  betContent: 'Selection',
  betStatus: 'Order status',
  betOrderNo: 'Order No.',
  betWon: 'Won',
  betLost: 'Lost',
  betPending: 'Pending',
  betRefunded: 'Refunded',
  betTypeSlots: 'Slots',
  betTypeLive: 'Live',
  betTypeSport: 'Sports',
  betTypeOriginal: 'Original',
  betTypeChess: 'Cards',
  betTypeFish: 'Fishing',
  payout: 'Payout accounts',
  security: 'Security',
  securityOn: 'On',
  kyc: 'Identity KYC',
  kycNone: 'Unverified',
  kycPending: 'Pending',
  kycRejected: 'Rejected',
  kycVerified: 'Verified',
  refer: 'Affiliate',
  referTip: 'Up to 25% commission',
  language: 'Language',
  logout: 'Log out',
  logoutConfirm:
    'Log out of this account? Your balance and records stay safe — sign in again anytime.',
  cancel: 'Cancel',
  langTitle: 'Language',
  langComing: 'Coming soon',
  comingSoon: 'Coming soon',
  recoverScanning: 'Scanning venue balances…',
  recoverEmpty: 'No stranded balances found',
  recoverOk: 'Recovered {amt}',
  recoverTickets: '{n} venue(s) queued for recovery',
  recoverOkAndTickets: 'Recovered {amt}; {n} venue(s) still processing',

  // —— Transfer ——
  tfAuto: 'Auto transfer',
  tfAutoDesc: 'When off, transfer funds into a venue manually before entering — no bulk parking',
  tfAutoAria: 'Auto transfer switch',
  tfOut: 'Out',
  tfIn: 'In',
  tfCentral: 'Main wallet',
  tfVenue: 'Game venue',
  tfAvailable: 'Available',
  tfVenueBal: 'Venue balance',
  tfAmtPlaceholder: 'Custom transfer amount',
  tfAll: 'All',
  tfSelectVenue: 'Select venue',
  tfSearchVenue: 'Search venue name',
  tfAllCats: 'All',
  tfMaint: 'Maintenance',
  tfPending: 'Auto-cashout',
  tfMapped: '¥ priced',
  tfEmptyVenue: 'No matching venue',
  tfLoading: 'Loading venues…',
  tfUnknown: '--',
  tfNote:
    "Min {min} · Instant, fee-free · venues under maintenance pause transfers; if a venue balance can't be transferred out, use “Recover” for one-tap auto-cashout.",
  tfConfirmIn: 'Confirm transfer in {name}',
  tfConfirmOut: 'Confirm transfer out {name}',
  tfBusy: 'Transferring…',
  tfMainAcct: '{code} main account',
  tfSwapAria: 'Swap transfer direction',
  tfErrMaint: '{name} under maintenance, transfers paused',
  tfErrPend: '{name} auto-cashout in progress, transfers unavailable',
  tfErrAmt: 'Enter a valid amount',
  tfErrMin: 'Min per transfer {min}',
  tfErrCentral: 'Main wallet available insufficient (up to {amt})',
  tfErrVenue: '{name} venue balance insufficient (up to {amt})',
  tfErrUnknown: '{name} venue balance unavailable, retry later or use Recover',
  tfErrTimeout: 'Transfer result unknown — do not retry; refresh the balance later',
  tfOkIn: 'Transferred into {name} {amt}',
  tfOkOut: 'Transferred out of {name} {amt}',
  tfAutoOn: 'Auto transfer on: balance follows you into venues',
  tfAutoOff: 'Auto transfer off: transfer funds manually before entering',
  tfEnterHint: 'Entering “{name}”: in-venue prices use ¥ = {code} (1:1), reversible in/out',

  // —— Notifications ——
  ntMarkAll: 'Mark all read',
  ntAllRead: 'All messages marked as read',
  ntEmpty: 'No notifications yet',
  ntLoading: 'Loading…',
  ntNote: 'Inbox keeps the last 90 days. Fund credits always follow wallet ledger entries.',
  ntDetailTitle: 'Message',
  ntKindFund: 'Funds',
  ntKindAct: 'Promo',
  ntKindSys: 'System',
  ntViewAria: 'View {title}',
  ntMissing: 'This message is no longer available',
  ntTabAll: 'All',
  ntTabFund: 'Funds',
  ntTabAct: 'Promos',
  ntTabSys: 'System',
}
